export const SparkMark = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 0L14.5922 8.4078 23 11L14.5922 13.5922 12 22L9.4078 13.5922 1 11L9.4078 8.4078 12 0Z"
      fill="url(#sparkGrad)"
    />
    <defs>
      <linearGradient
        id="sparkGrad"
        x1="0"
        y1="0"
        x2="24"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F472B6" />
        <stop offset="0.5" stopColor="#C084FC" />
        <stop offset="1" stopColor="#38BDF8" />
      </linearGradient>
    </defs>
  </svg>
);

export default function SparkLogo({ light = false }) {
  return (
    <span className="inline-flex items-center gap-2" data-testid="brand-logo">
      <SparkMark />
      <span
        className={`font-display text-xl font-semibold tracking-[0.08em] ${
          light ? "text-white" : "text-ink"
        }`}
      >
        SPARKWEAR
      </span>
    </span>
  );
}
